<template>
    <div>
        <loading v-if="loading"></loading>
        <div v-else class="grid grid-cols-1 xl:grid-cols-2 gap-16">
            <div v-if="!products.length" class="flex justify-center col-span-2">
                <span>{{ $t('general.no_results') }}</span>
            </div>
            <div v-else v-for="product in products" class="h-full">
                <div class="flex flex-col justify-between rounded border p-24 h-564 overflow-hidden shadow">
                    <div>
                        <div
                            v-if="product.free_board"
                            class="flex justify-center items-center bg-secondary rounded py-2 mb-24"
                        >
                            <p class="text-white">{{ $t('multi-posting.campaigns.form.free_board') }}</p>
                        </div>
                        <div class="flex justify-between mb-8">
                            <p>{{ `${product.duration.period} ${product.duration.range}` }}</p>
                            <p v-if="!Number.isNaN(product.vonq_price[0].amount) && product.vonq_price[0].amount > 0"><currency/>{{ product.vonq_price[0].amount.toFixed(2) }}</p>
                            <p v-else>{{ $t('multi-posting.price.free') }}</p>
                        </div>
                        <div class="flex items-center">
                            <svg-icon type="material-clock" class="w-16 h-16 mr-8" />
                            <span class="lowercase">{{ deliverTime(product) }}</span>
                        </div>
                    </div>
                    <div class="flex justify-center items-center w-full">
                        <img :src="product.logo_rectangle_url" alt="logo-undefined">
                    </div>
                    <div class="my-16">
                        <p class="text-heading-1 my-8">{{ product.name }}</p>
                        <a :href="product.url" target="_blank" class="break-words link-default">{{ product.url }}</a>
                    </div>
                    <div class="flex flex-col items-stretch gap-12 w-full">
                        <simple-button
                            v-if="isSelectedItem(product)"
                            display="danger"
                            look="primary"
                            class="grow w-full"
                            @click="removeFromCampaign(product)"
                        >
                            {{ $t('multi-posting.campaigns.form.remove_from_campaign') }}
                        </simple-button>
                        <simple-button
                            v-else
                            display="secondary"
                            look="primary"
                            class="grow w-full"
                            @click="addToCampaign(product)"
                        >
                            {{ $t('multi-posting.contracts.index.add_to_campaign') }}
                        </simple-button>

                        <simple-button
                            display="primary"
                            class="grow w-full"
                            @click="moreInformation(product)"
                        >
                            {{ $t('general.more_information') }}
                        </simple-button>
                    </div>
                </div>
            </div>
            <loading v-if="fetchingNextProducts" class="col-span-full my-24"></loading>
        </div>
    </div>
</template>

<script>
import Loading from "../../ui/Loading.vue";
import SimpleButton from "../../ui/SimpleButton.vue";
import SvgIcon from "../../ui/SvgIcon.vue";
import {mapActions, mapState} from "pinia";
import {useMultiPostingStore} from '../../../state/modules/multiPosting';
import Currency from "../../Currency.vue";

export default {
    name: 'Products',
    components: {SimpleButton, Loading, SvgIcon, Currency},
    props: {
        selectedItems: { type: Array, required: true },
        products: { type: Array, required: true },
        loading: { type: Boolean, default: true }
    },
    computed: {
        ...mapState(useMultiPostingStore, ['fetchingNextProducts']),
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['removeSelectedItemById', 'addSelectedItems']),
        deliverTime(product) {
            // always in hours
            const duration = product.time_to_process + product.time_to_setup;
            if (duration < 24)
                return `${duration} ${this.$tc('general.hours', duration)}`;
            const days = Math.floor(duration / 24);
            return `${days} ${this.$tc('general.working_days', days)}`;
        },
        isSelectedItem(product) {
            return this.selectedItems.filter(x => x.id === product.id).length > 0;
        },
        addToCampaign(product) {
            if (this.isSelectedItem(product)) {
                return;
            }
            this.addSelectedItems([{
                id: product.id,
                channel_id: product.channel_id,
                name: product.name,
                price: {
                    amount: product.vonq_price[0].amount,
                    currency: product.vonq_price[0].currency
                },
                duration: product.duration,
                type: 'product',
                logo_square_url: product.logo_square_url,
                time_to_process: product.time_to_process,
                time_to_setup: product.time_to_setup
            }]);
        },
        removeFromCampaign(product) {
            this.removeSelectedItemById({itemId: product.id});
        },
        moreInformation(product)  {
            this.$emit('more-information', product);
        }
    },
}
</script>
